import client from './client'

export const checkoutPurchase = ({ email, order, userUniqueId }) => {
	try {
		client.post('sale', {
			sale: order.number,
			visitor: userUniqueId,
			email,
			products: order.items.map((item) => ({
				id: item.parentSku ?? item.sku,
				price: item.price,
				quantity: item.qty,
			})),
		})
	} catch (e) {
		console.error(e)
	}
}
